function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "c#_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "c#_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c#_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "c-logo-(1)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "c-logo-(1)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c#_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.59973 0C0.716199 0 0 0.716359 0 1.59973L0 48.4003C0 49.2836 0.716199 50 1.59973 50L48.4003 50C49.2838 50 50 49.2836 50 48.4003L50 1.59973C50 0.716359 49.2838 0 48.4003 0L1.59973 0ZM18.2345 32.9789C13.7378 32.9789 10.0796 29.3955 10.0796 24.9908C10.0796 20.5962 13.7378 17.0211 18.2345 17.0211C20.2385 17.0211 22.1694 17.7458 23.6715 19.0617C24.2911 19.6045 24.3533 20.5468 23.8104 21.1663C23.2677 21.7861 22.3253 21.8486 21.7058 21.3053C20.748 20.4663 19.5151 20.004 18.2345 20.004C15.3827 20.004 13.0626 22.241 13.0626 24.9908C13.0626 27.7505 15.3827 29.9957 18.2345 29.9957C19.5128 29.9957 20.7526 29.5268 21.7254 28.6756C22.3453 28.1331 23.2876 28.196 23.8302 28.8159C24.3727 29.436 24.3098 30.3782 23.6899 30.9207C22.1732 32.2478 20.2358 32.9789 18.2345 32.9789ZM39.9203 27.4528C39.9203 28.2765 39.2525 28.9442 38.4287 28.9442L36.6899 28.9442L36.1496 31.3284C35.9926 32.0208 35.3775 32.4906 34.6962 32.4906C34.5869 32.4906 34.4761 32.4787 34.3652 32.4535C33.5618 32.2713 33.0582 31.4726 33.2403 30.6694L33.6313 28.9444L30.3996 28.9444L29.8593 31.3286C29.7023 32.021 29.0872 32.4908 28.4061 32.4908C28.2968 32.4908 28.1859 32.4788 28.0751 32.4537C27.2717 32.2715 26.7681 31.4727 26.9501 30.6695L27.3418 28.942C26.5408 28.9161 25.899 28.2602 25.899 27.4529C25.899 26.6292 26.5667 25.9615 27.3906 25.9615L28.0172 25.9615L28.4531 24.0386L27.3906 24.0386C26.5669 24.0386 25.899 23.3709 25.899 22.5474C25.899 21.7235 26.5667 21.0558 27.3906 21.0558L29.1293 21.0558L29.6697 18.6716C29.8517 17.8683 30.651 17.3646 31.454 17.5466C32.2574 17.7288 32.761 18.5276 32.579 19.3308L32.188 21.0558L35.4196 21.0558L35.96 18.6716C36.142 17.8683 36.9411 17.3646 37.7443 17.5466C38.5477 17.7288 39.0513 18.5276 38.8692 19.3308L38.4776 21.0583C39.2786 21.0843 39.9204 21.7402 39.9204 22.5475C39.9204 23.3711 39.2527 24.0388 38.4288 24.0388L37.8022 24.0388L37.3663 25.9617L38.4287 25.9617L38.4287 25.9614C39.2525 25.9614 39.9203 26.6291 39.9203 27.4528Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.23145 1.92271L3.66738 0L0.435766 0L0 1.92271L3.23145 1.92271Z",
  transform: "translate(31.076172 24.039062)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgC = function SvgC(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgC, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/c#.b5088e75.svg";
export { ForwardRef as ReactComponent };